import Skeleton from 'react-loading-skeleton';

import Typography from '~/shared/components/Typography';
import GrowActionIcon from '~/shared/assets/icons/grow-action.svg';
import ShrinkActionIcon from '~/shared/assets/icons/shrink-action.svg';
import Card from '~/shared/components/Card';

export default function OptimizationActions({
  totalActionsCount,
  totalActionsCountIsLoading,
  growActions,
  shrinkActions,
}: {
  totalActionsCount: number;
  totalActionsCountIsLoading: boolean;
  growActions: number;
  shrinkActions: number;
}) {
  return (
    <div className="">
      <div className=" flex items-center">
        {totalActionsCount !== undefined && !totalActionsCountIsLoading ? (
          <Typography fontWeight={500} variant="H5">
            Optimization Actions ({totalActionsCount})
          </Typography>
        ) : (
          <Skeleton
            containerClassName=" block  mt-auto flex items-end  leading-[unset!important]"
            className="h-[20px] leading-[unset!important] rounded-[8px] "
            baseColor="var(--color-gray-200)"
            highlightColor="#FFFF"
            width={150}
          />
        )}
      </div>
      <div className="hidden gap-[14px] mt-4">
        <OptimizationActionsCard
          title="Grow actions"
          icon={GrowActionIcon}
          count={growActions}
          isLoading={totalActionsCountIsLoading}
        />
        <OptimizationActionsCard
          title="Shrink actions"
          icon={ShrinkActionIcon}
          count={shrinkActions}
          isLoading={totalActionsCountIsLoading}
        />
      </div>
    </div>
  );
}

function OptimizationActionsCard({
  title,
  icon: Icon,
  count,
  isLoading,
}: {
  title: string;
  icon: React.ComponentType<{ className?: string }>;
  count: number;
  isLoading: boolean;
}) {
  return (
    <Card className="flex items-center gap-2 px-5 py-6 ">
      <Icon className="size-8" />
      <Typography fontWeight={500} variant="p3">
        {title}
      </Typography>
      {isLoading ? (
        <Skeleton
          containerClassName="ml-6 h-[24px] w-10 block my-auto leading-[unset!important]"
          className="h-[24px] leading-[unset!important]"
          baseColor="var(--color-gray-200)"
          highlightColor="#FFFF"
        />
      ) : (
        <Typography variant="H3-med" color="text-[#2D2D32]" className="ml-6 font-family-outfit">
          {count}
        </Typography>
      )}
    </Card>
  );
}
